var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeaveCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.1219 14.1523c.1338-.1338.1465-.3461.0335-.4979-.5459-.733-1.0271-1.5173-1.4353-2.3448l1.5716-1.1647c.5708-.42301.6747-1.23615.2286-1.78913l-3.0373-3.76493c-.4067-.5041-1.1311-.61406-1.66905-.25335l-1.66605 1.11712c-1.77793 1.19214-2.43216 3.4957-1.54625 5.44439l.64761 1.4245.00098.0021c.8294 1.8065 1.88262 3.4847 3.12519 5.0003.1389.1694.39327.1796.54819.0247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.9964 4.92947-19.95849 19.95843c-.01121.0112-.02264.0221-.03427.0326l-.04155.0416c-.36612.3661-.36612.9597 0 1.3258.36611.3661.95971.3661 1.32582 0l5.99949-5.9994c1.7625 1.4965 3.7548 2.7325 5.9203 3.6514l.8495.3785c1.9435.8659 4.2282.208 5.4136-1.5588l1.1101-1.6547c.3609-.538.251-1.2625-.2532-1.6693l-3.7648-3.0372c-.5529-.4461-1.3661-.3422-1.7891.2286l-1.1647 1.5716c-.9248-.4562-1.7957-1.0036-2.6013-1.6306l10.2801-10.28008c.3661-.36612.3661-.95971 0-1.32583-.3549-.35489-.9235-.36577-1.2915-.03262z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaveCall);
export default __webpack_public_path__ + "static/media/icon_leave_call.28e4ea6c4cd7d23dc1f5431da6e0c652.svg";
export { ForwardRef as ReactComponent };